import {
    ExtendedAccountColumns,
    ExtendedAccountData,
    ExtendedAddress,
} from '@/backend/features/contact-management/entities/extended-account/types';
import { AdditionAccountHeaderContent } from '@/ui/features/accounts/components';
import { AccountDetails, AccountDetailsProps } from '@juvare/contact-management/ui/features/accounts/components/AccountDetails';
import { OccupationInformation, PersonSubtitle } from '@juvare/credentialing/ui/features/person-credentials';
import { GetResponse } from '@juvare/platform-shared/features/storage';
import React from 'react';

export const RmsAccountDetails: React.FC<AccountDetailsProps> = (props) => {
    const extendedAccount = props.account as GetResponse<ExtendedAccountData, ExtendedAccountColumns>;
    const address = props.account.data.address as ExtendedAddress;

    return (
        <AccountDetails
            {...props}
            subTitle={<PersonSubtitle tribeId={address?.tribeId} county={address?.county} residenceType={address?.residenceType} />}
            additionalHeaderContent={
                <AdditionAccountHeaderContent accountId={extendedAccount.id} account={extendedAccount.data} cardStyle='slideout' />
            }
            additionalContent={<OccupationInformation personData={extendedAccount.data} />}
        />
    );
};
